export interface Theme {
  name: ThemeName;
  logo: React.FC;
  backdrop: {
    component?: React.FC;
  };
}

export enum ThemeName {
  BRANDLIVE_OLD = 'brandlive_old',
  BRANDLIVE = 'brandlive',
  WEBINAR_PLUS = 'webinarplus',
  BRANDTV = 'brandtv',
}
